import React from 'react';

import { Button } from 'src/common/button';
import { IconButton } from 'src/common/icon-button';

import ChromeLogo from 'src/icons/chrome-logo.svg';
import { CloseStrongIcon } from 'src/monet/icons';

interface Props {
  onDismiss: () => void;
}

const ShareSlideOverChromeExtensionInfo = ({ onDismiss }: Props) => {
  const extensionUrl = 'https://chrome.google.com/webstore/detail/journey/ndabgakchppcfcececfkebenibnfnkei';

  return (
    <>
      <div className='flex w-full justify-between items-start'>
        <p className='text-bedrock-p-small max-w-[264px]'>Quickly create and insert Journey links from within Google Chrome</p>
        <IconButton onClick={onDismiss}>
          <CloseStrongIcon />
        </IconButton>
      </div>
      <div className='flex w-full items-center space-x-5'>
        <a href={extensionUrl} target="_blank" rel="noopener noreferrer" className="w-full">
          <Button
            className='w-full'
            label='Install extension'
            variant='secondary'
            size='regular'
            type='button'
          />
        </a>
        <img src={ChromeLogo} alt='journey-stacks' className='w-8 h-8' />
      </div>
    </>
  );
};

export default ShareSlideOverChromeExtensionInfo;
